import { QueryClient, QueryCache, MutationCache } from "@tanstack/react-query";
import { ApiError } from "./errorHandler";

export const logoutUser = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("refreshToken");
  sessionStorage.clear();

  // Clear all TanStack query cache and store
  queryClient.clear();

  window.location.href = "/login";
};

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error) => {
      if (error instanceof ApiError && error.status === 401) {
        logoutUser();
      }
    },
  }),
  mutationCache: new MutationCache({
    onError: (error, _variables, _context, mutation) => {
      // Don't auto-redirect on login mutation failures
      const isLoginMutation = Boolean(mutation.meta?.isLogin);
      if (
        error instanceof ApiError &&
        error.status === 401 &&
        !isLoginMutation
      ) {
        logoutUser();
      }
    },
  }),
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      retry: (failureCount, error) => {
        // Do not retry 401 unauthorized errors
        if (error instanceof ApiError && error.status === 401) {
          return false;
        }
        return failureCount < 1;
      },
      refetchOnWindowFocus: false,
    },
  },
});

export default queryClient;
